export default __webpack_public_path__ + "static/media/b-doctor.cab00bcb.png";